import { PublicPage, LegalSection } from "../components/PublicPage";

const UPDATED = "juin 2026";

function Terms() {
  return (
    <PublicPage title="Conditions Générales d'Utilisation et de Vente" subtitle={`Dernière mise à jour : ${UPDATED}`} testid="legal-terms">
      <p>Les présentes CGU/CGV régissent l'accès et l'utilisation de la plateforme Cehnura (« le Service »), éditée par <strong>MusicInvestOnline</strong>. En créant un compte, vous acceptez ces conditions sans réserve.</p>
      <LegalSection heading="1. Objet">
        <p>Cehnura est un assistant de carrière pour créateurs et professionnels : gestion de projets, progression, marketplace de services, mise en relation et paiements associés.</p>
      </LegalSection>
      <LegalSection heading="2. Compte utilisateur">
        <p>Vous êtes responsable de la confidentialité de vos identifiants et de toute activité sur votre compte. Vous vous engagez à fournir des informations exactes et à jour.</p>
      </LegalSection>
      <LegalSection heading="3. Abonnements et paiements">
        <p>Le Service propose une offre gratuite ainsi que des abonnements payants (Premium 19,90 €/mois, Pro 49,90 €/mois). Les paiements sont traités par notre prestataire Stripe. Les abonnements sont sans engagement et résiliables à tout moment ; l'accès payant reste actif jusqu'à la fin de la période en cours.</p>
      </LegalSection>
      <LegalSection heading="4. Marketplace et prestations">
        <p>Les prestations entre membres font l'objet de devis. Une commission de 10 % est prélevée par la plateforme. Les fonds sont retenus (séquestre) puis reversés au professionnel après validation de la livraison par le client.</p>
      </LegalSection>
      <LegalSection heading="5. Droit de rétractation">
        <p>Conformément à l'article L221-28 du Code de la consommation, pour un service numérique dont l'exécution a commencé avec votre accord, le droit de rétractation peut ne pas s'appliquer.</p>
      </LegalSection>
      <LegalSection heading="6. Responsabilité">
        <p>Le Service est fourni « en l'état ». Cehnura ne saurait être tenue responsable des contenus publiés par les utilisateurs ni des relations contractuelles entre membres.</p>
      </LegalSection>
      <LegalSection heading="7. Résiliation">
        <p>Vous pouvez supprimer votre compte à tout moment depuis votre profil. Cehnura peut suspendre un compte en cas de manquement aux présentes conditions.</p>
      </LegalSection>
      <LegalSection heading="8. Droit applicable">
        <p>Les présentes conditions sont soumises au droit français. Tout litige relève des tribunaux compétents de <strong>Créteil</strong>.</p>
      </LegalSection>
    </PublicPage>
  );
}

function Privacy() {
  return (
    <PublicPage title="Politique de confidentialité" subtitle={`Conforme au RGPD · Dernière mise à jour : ${UPDATED}`} testid="legal-privacy">
      <p>Cette politique décrit comment <strong>MusicInvestOnline</strong>, responsable de traitement, collecte et traite vos données personnelles.</p>
      <LegalSection heading="1. Données collectées">
        <p>Compte (nom, email, mot de passe chiffré), profil, contenus créés, données d'usage, et données de paiement traitées par Stripe (Cehnura ne stocke aucune donnée de carte bancaire).</p>
      </LegalSection>
      <LegalSection heading="2. Finalités">
        <p>Fournir le Service, gérer les abonnements et paiements, assurer la sécurité, améliorer l'expérience et communiquer (bilans, rappels — désactivables).</p>
      </LegalSection>
      <LegalSection heading="3. Base légale">
        <p>Exécution du contrat (Service, paiements), consentement (emails marketing), intérêt légitime (sécurité, amélioration).</p>
      </LegalSection>
      <LegalSection heading="4. Sous-traitants">
        <p>Stripe (paiements), Google (connexion), prestataire d'emailing et d'hébergement. Certains peuvent traiter des données hors UE avec des garanties appropriées.</p>
      </LegalSection>
      <LegalSection heading="5. Conservation">
        <p>Les données sont conservées le temps de la relation contractuelle puis archivées selon les obligations légales. La suppression du compte entraîne l'effacement des données associées.</p>
      </LegalSection>
      <LegalSection heading="6. Vos droits">
        <p>Vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité, d'opposition et de limitation. Contact : <a href="mailto:support@cehnura.com" className="text-amber-400 hover:underline">support@cehnura.com</a>. Vous pouvez saisir la CNIL.</p>
      </LegalSection>
      <LegalSection heading="7. Cookies">
        <p>Cehnura utilise des cookies strictement nécessaires à l'authentification (session sécurisée). Aucun cookie publicitaire tiers n'est déposé.</p>
      </LegalSection>
    </PublicPage>
  );
}

function LegalNotice() {
  return (
    <PublicPage title="Mentions légales" subtitle={`Dernière mise à jour : ${UPDATED}`} testid="legal-notice">
      <LegalSection heading="Éditeur">
        <p><strong>MusicInvestOnline</strong> — représentée par Christopher Pistol<br />Siège : 32 avenue de Fontainebleau, 94270 Le Kremlin-Bicêtre, France<br />SIREN / SIRET : 839 593 944 / 839 593 944 00011<br />TVA intracommunautaire : non applicable — franchise en base de TVA (art. 293 B du CGI)<br />Email : <a href="mailto:support@cehnura.com" className="text-amber-400 hover:underline">support@cehnura.com</a></p>
      </LegalSection>
      <LegalSection heading="Directeur de la publication">
        <p>Christopher Pistol</p>
      </LegalSection>
      <LegalSection heading="Hébergement">
        <p>OVHcloud — OVH SAS, 2 rue Kellermann, 59100 Roubaix, France. Site : ovhcloud.com</p>
      </LegalSection>
      <LegalSection heading="Propriété intellectuelle">
        <p>L'ensemble des éléments de la plateforme (marque Cehnura, logo, interface) est protégé. Toute reproduction sans autorisation est interdite.</p>
      </LegalSection>
    </PublicPage>
  );
}

export default function Legal({ kind }) {
  if (kind === "privacy") return <Privacy />;
  if (kind === "mentions") return <LegalNotice />;
  return <Terms />;
}
